/* eslint-disable prefer-template */
/* eslint-disable no-param-reassign */
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { useState } from 'react';

import { useField } from '@unform/core';
import MaskedInput from 'react-text-mask';

import { Input as InputBase } from '~/components';
import { InputMaskProps, MaskType } from '~/models/Common';
import { convertMaskToInputMask } from '~/utils';

const InputMask: React.FC<InputMaskProps> = ({ name, mask, ...rest }) => {
  const [myMask] = useState<MaskType>(() => {
    if (typeof mask === 'string') {
      const converted = convertMaskToInputMask(mask);
      return converted;
    }

    return mask;
  });

  const { defaultValue } = useField(name);

  return (
    <MaskedInput
      mask={myMask}
      {...{ name, defaultValue }}
      {...rest}
      render={(ref, props) => <InputBase {...{ name, ref }} {...props} />}
    />
  );
};

export default InputMask;
